"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeographicalSanctionControlsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.GeographicalSanctionControlsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.geographical_sanction_controls.label',
    fallbackLabel: 'Elements subject to transaction sanction screening',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'COUNTIES_OF_INCORPORATION', label: 'fields.enm.geographical_sanction_controls.options.COUNTIES_OF_INCORPORATION', fallbackLabel: 'Countries of incorporation' },
        { key: 'BILLING_AND_SHIPPING_ADDRESSES', label: 'fields.enm.geographical_sanction_controls.options.BILLING_AND_SHIPPING_ADDRESSES', fallbackLabel: 'Billing and shipping addresses (to/from)' },
        { key: 'IP_ADDRESSES', label: 'fields.enm.geographical_sanction_controls.options.IP_ADDRESSES', fallbackLabel: 'IP addresses' },
        { key: 'NONE', label: 'fields.enm.geographical_sanction_controls.options.NONE', fallbackLabel: 'None of the above' },
    ],
    trackFieldValueWithAnalytics: false,
};
